<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>-->
    <router-view />
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { ACCESS_TOKEN } from "@/store/mutation-types";
import { getUrlParams, replaceParamVal } from "@/utils/utility";
var APPLEPAY = process.env.VUE_APP_APPLEPAY_TITLE;
import {
  connectWebViewJavascriptBridge,
  getBrowserUserAgent,
} from "@/utils/utility";
// import { log } from "console";
var userAgent = getBrowserUserAgent();
// import VConsole from 'vconsole';

// const isDebug = true;
// // 本地开发调试注入vConsole
// if (isDebug) {
//     new VConsole();
// }
export default {
  data() {
    return {};
  },
  mounted() {},
  created() {
    var token = getUrlParams("token");
    var webkey = getUrlParams("webkey");
    var userId = getUrlParams("userId");
    console.log(webkey)
    sessionStorage.setItem("webkey", webkey);

    if (sessionStorage.getItem("ApplePay")) {
    } else if(APPLEPAY){
      if(userAgent.ios){
        sessionStorage.setItem("ApplePay", APPLEPAY);
      }
      
    }
    if (localStorage.getItem("webkey")) {
    } else {
      localStorage.setItem("webkey", getUrlParams("webkey"));
    }
    if (userId != null && userId != "") {
      sessionStorage.setItem("userId", userId);
    }
    if (token != null && token != "") {
      this.SetToken(token);
      sessionStorage.setItem("Access-Token", token);
    }
    if (!sessionStorage.getItem("theme")) {
      sessionStorage.setItem("theme", getUrlParams("theme"));
    }
      if (getUrlParams("TenantId")) {
      sessionStorage.setItem("TenantId", getUrlParams("TenantId"));
    }
  },
  methods: {
    ...mapActions(["SetToken"]),
  },
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  font-weight: 400;
  font-size: 0.26rem;
}
body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
code,
form,
fieldset,
legend,
input,
button,
textarea,
p,
blockquote,
th,
td {
  margin: 0;
  padding: 0;
}
html,
body {
  height: 100%;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}
#app {
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  position: relative;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
